import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { AbstractionComponent } from '@biletix/core/common/abstraction-component';
import {Country} from "@biletix/core/models/country.model";
import { CountryService } from '@biletix/core/services/country.service';

@Component({
    selector: 'btx-flag-picker',
    templateUrl: './flag-picker.component.html',
    styleUrls: ['./flag-picker.component.scss'],
  standalone: false
})
export class FlagPickerComponent extends AbstractionComponent implements OnInit {

    @Input() selectedCountryCode?: string;
    countries: Country[]  = [];

    @Input() showFlags = true;
    @Input() showLabels = true;
    @Input() showArrow = true;

    @Output() changedCountryCode = new EventEmitter<string>();
    @Output() changedCountryPhonePrefix = new EventEmitter<string>();

    selectedCountry: Country | any;
    @Input() selectedPhonePrefix: string | any = "90";
    @Input() fieldName:string="phonePrefix";


    constructor(private countryService: CountryService) {
        super();
    }

    ngOnInit(): void {

        this.countryService.getAllCountry().pipe(this.takeUntilDestroy()).subscribe(countries=>{
            this.countries = countries;
            if (this.selectedPhonePrefix) {
                this.changeSelectedCountryPhonePrefix(this.selectedPhonePrefix);
            }
        });


    }


    public changeSelectedCountryPhonePrefix(phonePrefix: string | any): void {
        //console.log(this.countries);
        this.selectedCountry = this.countries?.find(item => item.phonePrefix == phonePrefix);
        if (this.selectedCountry) {
            this.selectedPhonePrefix = this.selectedCountry.phonePrefix;
            this.selectedCountryCode = this.selectedCountry.code;
            this.changedCountryCode.emit(this.selectedCountryCode);
            this.changedCountryPhonePrefix.emit(this.selectedPhonePrefix);
        }
    }

    getSvgIcon(code: string | any) {
        //Diğer ülke bayrakların resimleri svg olarak eklendiğinde tr kontrolü kalıdırılacak.
        if (!code || code.toLowerCase() != 'tr') {
            return '';
        }
        return code.toLowerCase();
    }

    // getCountryLabel(countryCode?: string): string {
    //     if (this.countries && this.countries.some(item => item.code == countryCode)) {
    //         this.selectedCountry = this.countries.find(item => item.code == countryCode);
    //         this.selectedPhonePrefix = this.selectedCountry.phonePrefix;
    //         return this.selectedCountry.name;
    //     }
    //
    //     return countryCode ? countryCode.toUpperCase() : '';
    // }
}
